export const TOGGLE_GRAPH_CRYPTO = "TOGGLE_GRAPH_CRYPTO";
export const SET_GRAPH_PERIOD = "SET_GRAPH_PERIOD";
export const SET_INITIAL_GRAPH_CRYPTO = "SET_INITIAL_GRAPH_CRYPTO";
